import { isFunction, isPlainObject } from 'es-toolkit';
export class Singleton {
    _instance;
    _readyPromise;
    _isReady = false;
    constructor() {
        if (!('init' in this) || typeof this.init !== 'function') {
            throw new Error('Singleton requires an init method to be defined.');
        }
        this._readyPromise = Promise.withResolvers();
        return new Proxy(this, {
            get: this.#proxyGetter,
            set: this.#proxySetter,
        });
    }
    get ready() {
        return this._readyPromise.promise;
    }
    get isReady() {
        return this._isReady;
    }
    get instance() {
        return this._instance;
    }
    set instance(instance) {
        this._instance = instance;
        this._isReady = true;
        this._readyPromise.resolve();
    }
    #proxyGetter = (target, prop, receiver) => {
        if (prop in target) {
            const resolvedReceiver = prop === 'instance' ? target : receiver;
            return Reflect.get(target, prop, resolvedReceiver);
        }
        if (target._instance && prop in target._instance) {
            const inst = target._instance;
            const value = inst[prop];
            return !isPlainObject(inst) && isFunction(value) ? value.bind(inst) : value;
        }
    };
    #proxySetter = (target, prop, value, receiver) => {
        if (!this._instance || prop in target) {
            return Reflect.set(target, prop, value, receiver);
        }
        if (target._instance && prop in target._instance) {
            target._instance[prop] = value;
            return true;
        }
        return false;
    };
}
